import React from 'react';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import InvoiceTable from '../components/InvoiceTable';
import { Box, Stack } from '@mui/material';
import useDocumentFilters from '../../../components/filters/DocumentFilterHelper';
import DocumentListFilters from '../../../components/filters/DocumentListFilters';

const filters = [
    {
        type: 'search',
        options: [
            { key: 'document_number', placeholder: 'Invoice Number' },
            { key: 'billed_to_name', placeholder: 'Buyer Name' },
            { key: 'billed_to_vat', placeholder: 'Buyer VAT' },
            { key: 'billed_by_name', placeholder: 'Seller Name' },
            { key: 'billed_by_vat', placeholder: 'Seller VAT' },
        ],
    },
];

function InvoiceListPage({ isPurchase=false}) {
    useDocumentTitle('Invoice List');

    const {
        selectedFilter,
        searchTerm,
        currentQuery,
        handleFilterChange,
        handleSearchChange,
        handleSearchKeyPress,
        handleStatusChange,
        handleDateRangeChange,
        handlePaginationChange,
    } = useDocumentFilters({ defaultQuery: {}, searchOnChange: true });

    return (
        <Stack direction="column" sx={{ mt: '-1rem' }}>
            <Box mb={2}>
                <DocumentListFilters
                    filters={filters}
                    selectedFilter={selectedFilter}
                    onFilterChange={handleFilterChange}
                    searchTerm={searchTerm}
                    onSearchChange={handleSearchChange}
                    onSearchKeyPress={handleSearchKeyPress}
                    onStatusChange={handleStatusChange}
                    onDateRangeChange={handleDateRangeChange}
                />
            </Box>
            <InvoiceTable
                handlePaginationChange={handlePaginationChange}
                searchQuery={currentQuery}
                isPurchase={isPurchase}
            />
        </Stack>
    );
}

export default InvoiceListPage;
